import React from 'react';
import { ModalLayout, Content, Title } from 'components';
import { Button, Divider, Flex, Table } from 'antd';
import RemoteArea from 'constants/RemoteArea';
import MessageAlert from 'utils';

const RemoteAreaModal = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { isOpened = false, onClose, onOk, data = [] } = props;

  /* ===== State ===== */
  const [checkedList, setCheckedList] = React.useState([...data]);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 체크박스 핸들러
   * --
   * @param {string} type
   * @param {object | array} obj
   */
  const handleCheckedList = (type, obj) => {
    const selectType = type.toLocaleUpperCase();

    let newObj;
    switch (selectType) {
      case 'CHECKED': // 개별 선택
        newObj = {
          ...obj,
        };
        setCheckedList((prev) => [...prev, newObj]);
        return;
      case 'UNCHECKED': // 개별 선택 해제
        setCheckedList((prev) =>
          prev.filter((select) => select.key !== obj.key)
        );
        return;
      case 'ALL-CHECKED': // 노출된 목록 전체 선택
        newObj = obj.map((area) => {
          const isExist = data?.find((item) => item.key === area) ?? null;

          if (isExist) {
            return isExist;
          } else {
            return {
              ...area,
            };
          }
        });
        setCheckedList(newObj);
        return;
      case 'ALL-UNCHECKED': // 노출된 목록 전체 선택 해제
        const removeList = checkedList.filter((area) =>
          obj.some((ob) => ob.key === area.key)
        );

        setCheckedList(removeList);

        return;
      default:
        return;
    }
  };

  const handleSubmit = () => {
    if (!onOk) {
      MessageAlert.info('설정 실패!');
      onClose();
      return;
    }

    onOk(checkedList);
    onClose();
  };

  /* ===== Variable ===== */
  const columns = React.useMemo(() => {
    return [
      {
        title: '지역명',
        dataIndex: 'city',
        key: 'city',
        width: 150,
      },
      {
        title: '우편번호',
        dataIndex: 'range',
        key: 'range',
        render: (item) => `${item[0]} ~ ${item[1]}`,
      },
    ];
  }, []);

  /* ===== Hooks ===== */
  React.useEffect(() => {
    if (!data.length) return;

    setCheckedList(data);
  }, [data]);

  /* ===== Render ===== */
  return (
    <ModalLayout
      open={isOpened}
      onCancel={onClose}
      width={500}
      centered
      footer={
        <Flex gap={4} justify="flex-end">
          <Button onClick={onClose}>취소</Button>
          <Button type="primary" onClick={() => handleSubmit()}>
            설정
          </Button>
        </Flex>
      }
    >
      <Content maxWidth={'100%'} padding={0}>
        <Title>도서산간지역 설정</Title>

        <Divider style={{ margin: '12px 0px' }} />

        <Table
          columns={columns}
          pagination={false}
          dataSource={RemoteArea}
          scroll={{ y: 500 }}
          rowSelection={{
            type: 'checkbox',
            onSelect: (record, selected) =>
              handleCheckedList(selected ? 'checked' : 'unchecked', record),
            onSelectAll: (selected, selectedRows) =>
              handleCheckedList(
                selected ? 'all-checked' : 'all-unchecked',
                selectedRows
              ),
            selectedRowKeys: checkedList.map((area) => area.key),
          }}
        />
      </Content>
    </ModalLayout>
  );
};

export default RemoteAreaModal;
